/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.0.0
 */
import { FC } from 'react';

import { EColorStatus } from '../../../../../modules/app/appConstants';
import getCellValue from '../../../helpers/getCellValue';
import { TABLE_NO_VALUE_OPTION } from '../../../sagas/loadTableMetaSagas';
import { TableTextDefaultValueStyled, TableTextStyled } from '../styled/TableBlockStyled';

export interface ITableTextBlockProps {
    className?: string;
    colorState?: EColorStatus.SUCCESS | EColorStatus.ERROR;
    defaultValue: string;
    noValue: string;
}

const TableTextBlock: FC<ITableTextBlockProps> = props => {
    const value = getCellValue(props.children);
    return (
        <>
            {
                value ?
                <TableTextStyled colorState={props.colorState}>
                    {value === TABLE_NO_VALUE_OPTION ? props.noValue : value }
                </TableTextStyled>
                :
                <TableTextDefaultValueStyled>
                    {props.defaultValue}
                </TableTextDefaultValueStyled>
            }
        </>
    );
};

TableTextBlock.defaultProps = {
    defaultValue: '',
};

export default TableTextBlock;
